import React, { useState } from 'react';

const ReturnModal = ({ items: initialItems, onClose, onConfirm, loading }) => {
  const [returnReason, setReturnReason] = useState('');
  const [selectedItems, setSelectedItems] = useState(initialItems);

  const handleQuantityChange = (index, quantity) => {
    const newSelectedItems = [...selectedItems];
    newSelectedItems[index].quantity = Math.min(
      Math.max(0, quantity), 
      newSelectedItems[index].maxQuantity
    );
    setSelectedItems(newSelectedItems);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const returnItems = selectedItems
      .filter(item => item.quantity > 0)
      .map(item => ({
        itemId: item.itemId,
        quantity: item.quantity,
        reason: returnReason
      }));

    if (returnItems.length === 0) {
      alert('Please select at least one item to return');
      return;
    }

    onConfirm({
      returnItems,
      reason: returnReason
    });
  };

  const totalRefund = selectedItems.reduce((sum, item) => 
    sum + (item.quantity * (item.priceAtSale || 0)), 0);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
        <h2 className="text-xl font-bold mb-4">Process Return</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Return Reason</label>
            <input
              type="text"
              value={returnReason}
              onChange={(e) => setReturnReason(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
              placeholder="Enter return reason"
              required
            />
          </div>

          <div className="mb-4">
            <h3 className="font-semibold mb-2">Select Items to Return</h3>
            <div className="max-h-64 overflow-y-auto">
              {selectedItems.map((item, index) => (
                <div key={item.itemId} className="flex items-center justify-between p-2 border-b">
                  <div className="flex-1">
                    <p className="font-medium">{item.productName}</p>
                    <p className="text-sm text-gray-600">Max: {item.maxQuantity}</p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <button
                      type="button"
                      onClick={() => handleQuantityChange(index, item.quantity - 1)}
                      disabled={item.quantity <= 0}
                      className="px-2 py-1 bg-gray-200 rounded"
                    >
                      -
                    </button>
                    <input
                      type="number"
                      value={item.quantity}
                      onChange={(e) => handleQuantityChange(index, parseInt(e.target.value) || 0)}
                      min="0"
                      max={item.maxQuantity}
                      className="w-16 p-1 border border-gray-300 rounded text-center"
                    />
                    <button
                      type="button"
                      onClick={() => handleQuantityChange(index, item.quantity + 1)}
                      disabled={item.quantity >= item.maxQuantity}
                      className="px-2 py-1 bg-gray-200 rounded"
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {totalRefund > 0 && (
            <div className="mb-4 p-3 bg-yellow-50 rounded">
              <p className="font-semibold">Total Refund: ${totalRefund.toFixed(2)}</p>
            </div>
          )}

          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Process Return'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReturnModal;